var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02Ecstatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z",
    fill: "#F47C39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.4286 55.5707C19.8601 55.5707 6.42875 42.1393 6.42875 25.5709C6.42875 16.7189 10.2633 8.76372 16.3612 3.27246C6.64894 8.23837 0 18.3425 0 29.9996C0 46.5681 13.4314 59.9994 29.9998 59.9994C37.7165 59.9994 44.7517 57.085 50.0672 52.2982C45.9753 54.3903 41.34 55.5707 36.4286 55.5707Z",
    fill: "#891A1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3641 50.1434C27.6575 50.1434 22.2207 44.7066 22.2207 38H46.5074C46.5074 44.7066 41.0706 50.1434 34.3641 50.1434Z",
    fill: "#891A1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8163 21.934C28.1422 21.934 27.5959 21.3876 27.5959 20.7136C27.5959 19.1395 26.3153 17.8587 24.741 17.8587C23.1668 17.8587 21.8861 19.1396 21.8861 20.7136C21.8861 21.3877 21.3396 21.934 20.6657 21.934C19.9916 21.934 19.4453 21.3876 19.4453 20.7136C19.4453 17.7936 21.821 15.418 24.741 15.418C27.6609 15.418 30.0367 17.7936 30.0367 20.7136C30.0368 21.3876 29.4903 21.934 28.8163 21.934Z",
    fill: "#891A1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4296 21.934C48.7555 21.934 48.2092 21.3876 48.2092 20.7136C48.2092 19.1395 46.9286 17.8587 45.3543 17.8587C43.78 17.8587 42.4994 19.1396 42.4994 20.7136C42.4994 21.3877 41.9529 21.934 41.279 21.934C40.605 21.934 40.0586 21.3876 40.0586 20.7136C40.0586 17.7936 42.4343 15.418 45.3543 15.418C48.2742 15.418 50.6499 17.7936 50.6499 20.7136C50.6501 21.3876 50.1036 21.934 49.4296 21.934Z",
    fill: "#891A1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1836 38V39.8956C25.1836 40.6949 25.8315 41.3428 26.6307 41.3428H42.0973C42.8966 41.3428 43.5444 40.6948 43.5444 39.8956V38H25.1836Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6191 45.1057C31.3366 43.5806 27.694 43.8022 24.7402 45.3839C26.9598 48.2768 30.4503 50.1436 34.3783 50.1436C36.1094 50.1436 37.7543 49.7789 39.2446 49.1261C38.1513 47.4347 36.5837 46.0185 34.6191 45.1057Z",
    fill: "#FC4C59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Ecstatic);
export default __webpack_public_path__ + "static/media/02-Ecstatic.0d7707ecbb01ff15fe7bc86bec306ce1.svg";
export { ForwardRef as ReactComponent };